import { render, staticRenderFns } from "./player-notation.vue?vue&type=template&id=450f5a73&scoped=true&"
import script from "./player-notation.vue?vue&type=script&lang=js&"
export * from "./player-notation.vue?vue&type=script&lang=js&"
import style0 from "./player-notation.vue?vue&type=style&index=0&id=450f5a73&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450f5a73",
  null
  
)

export default component.exports